export default __webpack_public_path__ + "static/media/maszul.61499adf.jpg";